import { Component,Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
})
export class AlertDialogComponent implements OnInit {
  msg: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AlertDialogComponent>
  ) {}

  ngOnInit(): void {
    this.msg = this._data?.msg;
  }

    
  close(select: any) {   
      this.dialogRef.close(select);
  }

}
